import { createSelector } from 'reselect';

const gettingStarted = (store) => store.apps.gettingStarted;

const appUploadSelector = createSelector(
  [gettingStarted],
  (gettingStartedStore) => gettingStartedStore.appUpload,
);

export { appUploadSelector };
